import type { Renderable } from '@adornis/functional-lit/renderable.js';
import { webcomponent } from '@adornis/functional-lit/webcomponent.js';

/**
 * Renders `content` in its own shadow root that adopts the app's Tailwind sheet.
 *
 * Legacy chemistry hosts — the `x-data-view` table cells, the XSnackbar — render into shadow roots that only carry
 * their own ASS styles, so daisyUI/Tailwind classes placed there silently do nothing. Wrap such content in this.
 * ponytail: goes away with the data-view and snackbar migration.
 */
export const TailwindScope = webcomponent('tailwind-scope', (props: { content: Renderable }) => props.content, {
  shadowRoot: true,
});
